export interface IDocumentDocumentTemplateContent {
    content: string;
}

export class DocumentDocumentTemplateContent implements IDocumentDocumentTemplateContent {
    content: string;

    constructor();
    constructor(obj: IDocumentDocumentTemplateContent);
    constructor(obj?: any) {
        this.content = obj && obj.content || "";
    }
}